import React, { useState } from 'react';

const TABS = [
  { id: 'stats', label: 'Overview', icon: '📊' },
  { id: 'users', label: 'Users', icon: '👥' },
  { id: 'listings', label: 'Listings', icon: '🚕' },
  { id: 'contact-messages', label: 'Messages', icon: '✉️' },
  { id: 'ads', label: 'Advertisements', icon: '📢' },
  { id: 'audit-logs', label: 'Audit Logs', icon: '📋' },
  { id: 'reports', label: 'Reports', icon: '📧' }
];

const AdminSidebar = ({ activeTab, setActiveTab, resetPagination }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    resetPagination();
    setMobileOpen(false);
  };

  return (
    <>
      <button
        className="admin-sidebar-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle admin menu"
      >
        <span className="sidebar-toggle-icon">{mobileOpen ? '✕' : '☰'}</span>
        <span className="sidebar-toggle-label">
          {TABS.find(t => t.id === activeTab)?.label}
        </span>
      </button>

      {mobileOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          {!collapsed && <h2>Admin</h2>}
          <button
            className="sidebar-collapse-btn"
            onClick={() => setCollapsed(!collapsed)}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? '▶' : '◀'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`sidebar-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabClick(tab.id)}
              title={collapsed ? tab.label : undefined}
            >
              <span className="sidebar-nav-icon">{tab.icon}</span>
              {!collapsed && <span className="sidebar-nav-label">{tab.label}</span>}
            </button>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default AdminSidebar;
